import { render, staticRenderFns } from "./crash-games.vue?vue&type=template&id=7619fb46"
import script from "./crash-games.vue?vue&type=script&lang=js"
export * from "./crash-games.vue?vue&type=script&lang=js"
import style0 from "./crash-games.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/crash-games.vue
// module id = 9pWW
// module chunks = 0